/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_Mobile_CtaInputs */

const en_nav_aria_mobile_cta = /** @type {(inputs: Nav_Aria_Mobile_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile call to action`)
};

const es_nav_aria_mobile_cta = /** @type {(inputs: Nav_Aria_Mobile_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llamada a la acción móvil`)
};

/**
* | output |
* | --- |
* | "Mobile call to action" |
*
* @param {Nav_Aria_Mobile_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_aria_mobile_cta = /** @type {((inputs?: Nav_Aria_Mobile_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_Mobile_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_aria_mobile_cta(inputs)
	return en_nav_aria_mobile_cta(inputs)
});